import { render, staticRenderFns } from "./CouponManege.vue?vue&type=template&id=f5a3e0a0&scoped=true&"
import script from "./CouponManege.vue?vue&type=script&lang=js&"
export * from "./CouponManege.vue?vue&type=script&lang=js&"
import style0 from "./CouponManege.vue?vue&type=style&index=0&id=f5a3e0a0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5a3e0a0",
  null
  
)

export default component.exports